import moment, { Moment } from "moment";
import { memo, useState } from "react";
import { SingleDatePicker } from "react-dates";
import styled from "styled-components";

import { ReactComponent as CalendarIcon } from "../../assets/calendar.svg";

import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";

/* https://github.com/airbnb/react-dates/issues/1030
 * In-order to extend styling, wrapper div around date picker is needed.
 */

const StyledDatePickerWrapper = styled.div`
  & .SingleDatePicker,
  .SingleDatePickerInput {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 700;
    font-size: 10px;
    line-height: 120%;
    .DateInput {
      width: 100%;
      height: 40px;
      display: flex;
      flex-direction: row;
      .DateInput_input {
        font-weight: 400;
        font-size: 13px;
        color: #212529;

        display: flex;
        align-items: center;
        border-bottom: 0;
        padding: 12px 16px 14px;
      }
    }

    .SingleDatePickerInput {
      display: flex;
      flex-direction: row;
      &__withBorder {
        border: 1px solid #e5e5e5;
        border-radius: 5px;
        overflow: hidden;
        &:hover,
        &.focus {
          border-color: #0075bc;
          box-shadow: inset 0 1px 1px rgba(0, 117, 188, 0.075),
            0 0 8px rgba(0, 117, 188, 0.6);
        }
      }
    }
    .CalendarMonth_caption {
      line-height: 120%;
      text-align: center;
    }
    .CalendarDay {
      border-radius: 2px;
      font-size: 10px;

      &:hover {
        color: white;
        background: #0075bc;
        border: 1px solid #0075bc;
      }
      &__selected {
        background: #0075bc;
        border: 1px solid #0075bc;
      }
    }
  }
`;
interface DatePickerProps {
  date?: string;
  minDate?: string;
  maxDate?: string;
  onChange: (date?: string) => void;
}
export const DatePicker = memo(function Comp(props: DatePickerProps) {
  const [focused, setFocused] = useState<boolean>(false);
  return (
    <StyledDatePickerWrapper>
      <SingleDatePicker
        id="inputs-datepicker"
        displayFormat={"DD-MM-YYYY"}
        numberOfMonths={1}
        onDateChange={(momentDate) =>
          props.onChange && props.onChange(momentDate?.format("YYYY-MM-DD"))
        }
        onFocusChange={({ focused }) => setFocused(focused)}
        focused={focused}
        date={props.date ? moment(props.date) : null}
        daySize={30}
        firstDayOfWeek={1}
        enableOutsideDays
        showDefaultInputIcon
        hideKeyboardShortcutsPanel
        placeholder="Maak een keuze"
        customInputIcon={<CalendarIcon fill="#212529" />}
        isDayBlocked={(day: Moment) =>
          (Boolean(props.maxDate) &&
            day.isAfter(moment(props.maxDate), "day")) ||
          (Boolean(props.minDate) && day.isBefore(moment(props.minDate), "day"))
        }
        isOutsideRange={() => false}
      />
    </StyledDatePickerWrapper>
  );
});

export default DatePicker;
